import Vue from 'vue'
import VueRouter from 'vue-router'
import VueHead from 'vue-head'

import '@babel/polyfill'

import BootstrapVue from 'bootstrap-vue'

// Import Icons and App Custom Styles
// import './css/icons.css'
// import './css/app.css'

import '@fortawesome/fontawesome-free/css/fontawesome.min.css'

import '@fortawesome/fontawesome-free/css/brands.min.css'
import '@fortawesome/fontawesome-free/css/regular.min.css'
import '@fortawesome/fontawesome-free/css/solid.min.css'

import '@mdi/font/css/materialdesignicons.min.css'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.min.css'

import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'

import VueInfiniteLoading from 'vue-infinite-loading'

import VueSelect from 'vue-select'

import 'vue-select/dist/vue-select.css'

import VueMonthlyPicker from 'vue-monthly-picker'

import dayjs from 'dayjs'

import { ValidationProvider, ValidationObserver, localize, extend } from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja.json'
import { required, numeric, min, max, min_value, max_value, between, email, regex, confirmed } from 'vee-validate/dist/rules'
import { kana, tel, date, time } from './utils/rules'

import App from './App.vue'
import router from './router'
import { store } from './utils/store'
import { Auth0Plugin } from './plugins/auth'

import common from './mixins/common'

Vue.use(VueHead)
Vue.use(VueRouter)

extend('required', required)
extend('numeric', numeric)
extend('min', min)
extend('max', max)
extend('min_value', min_value)
extend('max_value', max_value)
extend('between', between)
extend('email', email)
extend('regex', regex)
extend('confirmed', confirmed)
extend('kana', kana)
extend('tel', tel)
extend('date', date)
extend('time', time)

extend('isEmployableYear', {
  validate: (val) => {
    try {
      let years = dayjs().diff(`${String(val)}/1/1`, 'years')
      if (years < 10) {
        return false
      } else if (years > 110) {
        return false
      } else {
        return true
      }
    } catch (e) {
      console.log(e)
      return false
    }
  },
  message:
    '雇用に適した年齢ではありません'
})

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
localize('ja', ja)

Vue.mixin(common)

const domain = process.env.VUE_APP_AUTH0_DOMAIN
const clientId = process.env.VUE_APP_AUTH0_CLIENT_ID
const audience = process.env.VUE_APP_AUTH0_AUDIENCE

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    )
  }
})

Vue.use(BootstrapVue)

Vue.use(VueSidebarMenu)

Vue.use(VueInfiniteLoading, { /* options */ })

Vue.component('v-select', VueSelect)

Vue.component('v-monthly-picker', VueMonthlyPicker)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  // Bootstrap,
  render: h => h(App),
  beforeCreate () {
    this.$store.commit('initializeStore')
  }
}).$mount('#app')
